// sun #3936 / jupiter #3059 — Sun blocks creating or saving a fabrication order when one operation of its workflow
// needs a technology no machine has. Its message is technical (and in English); the body also carries the data
// (`error: 'NO_MACHINE_FOR_TECHNOLOGY'`, `operation`, `technology`, `external`) so the user reads a plain,
// translated sentence that says what to fix.
export const NO_MACHINE_FOR_TECHNOLOGY = 'NO_MACHINE_FOR_TECHNOLOGY'

/** Whether Sun blocked the fabrication order because no machine has the technology of one of its operations. */
export const isNoMachineForTechnologyError = (error) => error?.data?.error === NO_MACHINE_FOR_TECHNOLOGY

/**
 * The text to show for a failed create/save of a fabrication order.
 * @param {Object} error The error `apiPost`/`apiPut` throw (`{ status, data, message }`)
 * @param {Function} t_ The translation function
 * @returns {string}
 */
export const fabricationOrderSaveErrorMessage = (error, t_) => {
  if (!isNoMachineForTechnologyError(error)) {
    return t_(error?.message || '')
  }
  const data = error.data
  const values = { operation: data.operation || '', technology: data.technology || '' }
  return data.external === true
    ? t_('The fabrication order cannot be saved because no subcontracting machine can do the external operation "{{operation}}" ({{technology}}). Assign that technology to an external machine or change the operation in the workflow.', values)
    : t_('The fabrication order cannot be saved because no machine can do the operation "{{operation}}" ({{technology}}). Assign that technology to a machine or change the operation in the workflow.', values)
}
